import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const UserName = 'UserName'
const BbsTokenKey = 'userToken'
const expires = 7;

export function getToken () {
  return Cookies.get(TokenKey)
}

export function getBbsToken () {
  return Cookies.get(BbsTokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token, { expires, path: '/' })
}

export function setBbsToken (token) {
  // cookie 有效期为7天
  return Cookies.set(BbsTokenKey, token, { expires, path: '/' })
}

export function removeBbsToken () {
  Cookies.remove(BbsTokenKey, { path: '/' })
}

export function removeToken () {
  Cookies.remove(TokenKey, { path: '/' })
  removeBbsToken()
}

export function setUserName (name) {
  const normalizedName = normalizeUserName(name)
  if (!normalizedName) {
    return removeUserName()
  }
  return Cookies.set(UserName, normalizedName, { expires, path: '/' })
}

export function removeUserName () {
  return Cookies.remove(UserName, { path: '/' })
}

export function getUserName () {
  const storedName = Cookies.get(UserName)
  const normalizedName = normalizeUserName(storedName)
  // Repair cookies written by older QR-login responses that stored a JSON object.
  if (normalizedName && normalizedName !== storedName) {
    Cookies.set(UserName, normalizedName, { expires, path: '/' })
  }
  return normalizedName
}

// Login responses have historically exposed username as either a string or a
// serialized sql.NullString object. Keep the display name scalar everywhere.
export function normalizeUserName (value) {
  if (value === null || value === undefined) return null

  if (typeof value === 'string') {
    const trimmed = value.trim()
    if (!trimmed || trimmed === '[object Object]') return null
    if (trimmed[0] === '{' || trimmed[0] === '[') {
      try {
        return normalizeUserName(JSON.parse(trimmed))
      } catch (error) {
        return trimmed
      }
    }
    return trimmed
  }

  if (typeof value === 'object') {
    if (value.Valid === false) return null
    const candidates = [
      value.String,
      value.string,
      value.nickname,
      value.nickName,
      value.realName,
      value.username,
      value.Username,
    ]
    for (const candidate of candidates) {
      const normalizedCandidate = normalizeUserName(candidate)
      if (normalizedCandidate) return normalizedCandidate
    }
    return null
  }

  return String(value).trim() || null
}
